import { createApiClient } from "../../api/apiClient";
import { AppDispatch } from "../index";
import { setLocationWithAccess } from "../slices/appDataSlice";

/**
 * Reload user profile from server to refresh cached data.
 * Use this after admin operations that change user permissions (e.g., sustainTeamMember flag).
 * 
 * This ensures the frontend cache stays in sync with backend database changes.
 * 
 * @returns Promise that resolves to the fresh location data
 * 
 * @example
 * // After admin updates user:
 * await api.put(`/api/admin/users/${userId}`, { sustainTeamMember: true });
 * await dispatch(reloadUserProfile());
 * toast.show("User updated successfully", "success");
 */
export const reloadUserProfile = () => async (dispatch: AppDispatch) => {
  try {
    const api = createApiClient();
    const response = await api.post("/common/location-with-access");
    dispatch(setLocationWithAccess(response));
    return response;
  } catch (error) {
    console.error("[reloadUserProfile] Failed to reload user profile:", error);
    throw error;
  }
};
